import { FC } from "react";
import { GenericModal } from "./GenericModal";
import { ConnectToPrinterWarning } from "crossdock/common/zebra/ConnectToPrinterWarning";
import { PrepRequiredModal } from "./PrepRequiredModal";

export const genericModalMap: Record<GenericModal, FC<any>> = {
  [GenericModal.CONNECT_TO_PRINTER_WARNING]: ConnectToPrinterWarning,
  [GenericModal.PREP_REQUIRED]: PrepRequiredModal,
};
